import React, { useState } from "react";
import styled from "styled-components";
import { Accordion } from "./components/setting-accordion";
import Icon from '@material-ui/core/Icon';
import SettingIcon from "../../../../../../images/settings-icons/setting-check-in.png";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import moment from "moment";
import {UserCheckinWarning} from './components/user-check-in-warning'
import EditCheckin from './components/edit-weighin'
import EditCheckWeighin from './components/edit-check-weighin'
import { hostDateToString, getDaysSinceWeighIn, getCarryOverEnvironment } from '../../util'
import iconWarning from '../../../../../../images/coaching-messages/greenChart.png'

const LBS_PER_KG = 2.204622

const DataRow = styled.div`
  /* background: ${props => props.highlight ? '#bfe8bf': 'none'}; */
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  p {
    margin: 0px 16px;
  }

  .weight {
    width: 100px;
  }

  .fat {
    width: 80px;
  }

  .date {
    width: 140px;
  }
`;

const UpdateRecentCheckin = (props) => {
  const [show, setShow] = useState(false);
  const [showEditMessage, setShowEditMessage] = useState(false);
  const [showUserCheckinWarning, setShowUserCheckinWarning] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showEditCheckForm, setShowEditCheckForm] = useState(false);
  const [selectedWeighInIndex, setSelectedWeighInindex] = useState(0);

  const daysAfterLastCheckIn = getDaysSinceWeighIn(props.lastWeighInDate);

  const isToday = (weighInDate) => {
    const today = new Date()
    const reportDate = new Date(weighInDate)
    return (reportDate.getUTCFullYear() === today.getFullYear() && reportDate.getUTCMonth() === today.getMonth() && reportDate.getUTCDate() === today.getDate()) ? true : false
  }

  const createEditButton = (index, reportDate) => {
    const daysSinceWeighIn = getDaysSinceWeighIn(reportDate)
  
    if (daysAfterLastCheckIn >= 1 && daysAfterLastCheckIn < 5) {
      // Check edit
      if(index === 0) {
        return (
          <button 
            className='widget-table-edit-button' 
            onClick={() => { setSelectedWeighInindex(index); setShowEditMessage(true); }}
          >
            <Icon className="material-icons" id='table-edit-icon'>mode_edit</Icon>
          </button>
        )
      }
    } else if (daysAfterLastCheckIn >= 5) {
      // No edit allowed
      if(index === 0) {
        return (
          <button 
            className='widget-table-edit-button' 
            onClick={() => { setShowUserCheckinWarning(true); }}
          >
            <Icon className="material-icons" id='table-edit-icon'>mode_edit</Icon>
          </button>
        )
      }
    } else {
      // Edit allowed
      if(index === 0 || (daysSinceWeighIn < 5 && isToday(props.weighins[0].report_date))) {
        return (
          <button 
            className='widget-table-edit-button' 
            onClick={() => { setSelectedWeighInindex(index); setShowEditForm(true) }}
          >
            <Icon className="material-icons" id='table-edit-icon'>mode_edit</Icon>
          </button>
        )
      }
    }
  }

  // Check-in form props
  let potentiallyKeepable = false
  let carryOverEnvironment = null
  let keep = 0
  let reasonCode = 0
  let reasonText = ''
  if(props.user.weighins) {
    if(selectedWeighInIndex + 1 < props.user.weighins.length) {
      const selectedWeighIn = props.user.weighins[selectedWeighInIndex]            
      const previousWeighIn = props.user.weighins[selectedWeighInIndex + 1]
      carryOverEnvironment = getCarryOverEnvironment(selectedWeighIn, previousWeighIn)
      potentiallyKeepable = carryOverEnvironment.potentiallyKeepable
      if(potentiallyKeepable) {
        if(selectedWeighIn.keep !== null) {
          keep = selectedWeighIn.keep
          reasonCode = selectedWeighIn.reason_code
          reasonText = selectedWeighIn.reason_text
        }
      }
    }
  }

  let recentCheckins = props.weighins
  recentCheckins = recentCheckins.slice(0, 6)

  //Tracked Averages props
  let relatedWeighInDateString = null
  let relatedWeighInDetails = null
  for(let key in props.macroData.weighInDetails) {
    if(key <= props.timeline.selectedDay && (relatedWeighInDateString === null || key > relatedWeighInDateString)) {
      relatedWeighInDateString = key
    }
  }
  if(relatedWeighInDateString !== null) {
    relatedWeighInDetails = props.macroData.weighInDetails[relatedWeighInDateString]
  }

  return (
    <>
      <Accordion
        show={show}
        setShow={setShow}
        icon={SettingIcon}
        settingName="Edit a recent check-in"
        roundBottom
        alternateColor
      >
        <>
          <DataRow>
            <p className="date" style={{fontWeight: 'bold'}}>Date</p>
            <p className="weight" style={{fontWeight: 'bold'}}>Weight</p>
            <p className="fat" style={{fontWeight: 'bold'}}>Body fat</p>
            <p className="weight" style={{fontWeight: 'bold'}}>LBM</p>
            <p className="fat" style={{fontWeight: 'bold'}}>Compliant</p>
            <div className="fat"></div>
          </DataRow>
          {recentCheckins.map((checkin, index) => 
            {
              let weight = (checkin.edited_weight) ? checkin.edited_weight : checkin.weight
              weight = (checkin.estimated_weight) ? checkin.estimated_weight : weight // NOTE: If a user has an estimated weight, show that estimated weight.
              weight *= LBS_PER_KG

              const bodyfat = (checkin.edited_body_fat) ? checkin.edited_body_fat : checkin.body_fat
              const date = hostDateToString(checkin.report_date)

              return (
                <DataRow highlight={(index === 0)}>
                  <p className="date">{moment.utc(date).format('MMM D, YYYY')}</p>
                  <p className="weight">{Number(weight).toFixed(1)} lbs</p>
                  <p className="fat">{bodyfat}%</p>
                  <p className="weight">{Number(weight*(1-bodyfat/100)).toFixed(1)} lbs</p>
                  <p className="fat">{checkin.compliant ? "Yes" : "No"}</p>
                  <div className="fat">{createEditButton(index, checkin.report_date)}</div>
                </DataRow>
              )
            }
          )}
        </>
      </Accordion>

      <Dialog
        open={showEditMessage}
        onClose={() => setShowEditMessage(false)}
      >
        <DialogContent className="avn-modal-content-container">
          <img src={iconWarning} alt="coaching-icon" />
          <h4>Warning</h4>
          <p>
            If you choose to edit this user's weight, body fat, or any other parameter
            associated with this check-in, this user's macro targets may change. Any
            major change to this user's existing macro targets will require a
            check in, as the system will need an accurate starting point
            to determine the effect of the new macros on this user's body. This will
            also push this user's next check-in back 7 days.
          </p>
        </DialogContent>
        <DialogActions className='avn-modal-actions-container'>
          <button
            className="avn-modal-action"
            onClick={() => {
              setShowEditMessage(false)
              setShowEditCheckForm(true)
            }}
          >
            Continue
          </button>
          <button
            className="avn-modal-action-cancel"
            onClick={() => {
              setShowEditMessage(false)
            }}
          >
            Cancel
          </button>
        </DialogActions>
      </Dialog>

      <UserCheckinWarning
        open={showUserCheckinWarning}
        onClose={() => setShowUserCheckinWarning(false)}
        daysAfterLastCheckIn={daysAfterLastCheckIn}
      />

      <EditCheckin
        open={showEditForm}
        onClose={() => setShowEditForm(false)}
        openFeedback={props.openSnackbar}
        userId={props.userId}
        portalId={props.portalId}
        loadPortalAccount={props.loadPortalAccount}
        weightString={props.weightString}
        previousWeight={props.previousWeight}
        previousBodyfat={props.previousBodyfat}
        useMetricUnits={props.useMetricUnits}
        daysAfterLastCheckIn={daysAfterLastCheckIn}

        weighins={props.user.weighins}
        selectedWeighInIndex={selectedWeighInIndex}
        potentiallyKeepable={potentiallyKeepable}
        carryOverEnvironment={carryOverEnvironment}
        keep={keep}
        reasonCode={reasonCode}
        reasonText={reasonText}
        gender={props.user.gender}
        height={props.user.height}
        skipNearPeriod={props.user.skip_near_period}
        nearPeriod={props.user.near_period}
        startingPoint={props.user.starting_point}
        estimatedWeight={props.user.estimated_weight}
        // calories={props.user.calories}
        protein={props.user.protein}
        carbs={props.user.carbs}
        fat={props.user.fat}
        goal={props.user.goal}
        goalLevel={props.user.goal_level}
        // useMetricUnits={props.user.use_metric_units}
        fullname={props.user.full_name}
        user={props.user}
        dailyWeights={props.user.daily_weights}

        // TrackedAverages props
        // user={props.user}
        // userId={props.user.id}
        timeline={props.timeline}
        relatedWeighInDateString={relatedWeighInDateString}
        relatedWeighInDetails={relatedWeighInDetails}
        usingMovingTargets={props.macroData.movingTargets}
        modifiedSlider={props.macroData.part4Invoked}
        macroData={props.macroData}
        getMacroData={props.getMacroData}
      />

      <EditCheckWeighin
        skipMessage
        editCheckin
        editTodayCheckin={false}
        open={showEditCheckForm}
        onClose={() => setShowEditCheckForm(false)}
        openFeedback={props.openSnackbar}
        userId={props.userId}
        portalId={props.portalId}
        loadPortalAccount={props.loadPortalAccount}
        weightString={props.weightString}
        previousWeight={props.previousWeight}
        previousBodyfat={props.previousBodyfat}
        useMetricUnits={props.useMetricUnits}
        daysAfterLastCheckIn={daysAfterLastCheckIn}

        weighins={props.user.weighins}
        selectedWeighInIndex={selectedWeighInIndex}
        potentiallyKeepable={potentiallyKeepable}
        carryOverEnvironment={carryOverEnvironment}
        keep={keep}
        reasonCode={reasonCode}
        reasonText={reasonText}
        gender={props.user.gender}
        height={props.user.height}
        skipNearPeriod={props.user.skip_near_period}
        nearPeriod={props.user.near_period}
        startingPoint={props.user.starting_point}
        estimatedWeight={props.user.estimated_weight}
        // calories={props.user.calories}
        protein={props.user.protein}
        carbs={props.user.carbs}
        fat={props.user.fat}
        showEditCheckModal={false}
        // useMetricUnits={props.user.use_metric_units}
        fullname={props.user.full_name}
        user={props.user}
        dailyWeights={props.user.daily_weights}

        // TrackedAverages props
        // user={props.user}
        // userId={props.user.id}
        timeline={props.timeline}
        relatedWeighInDateString={relatedWeighInDateString}
        relatedWeighInDetails={relatedWeighInDetails}
        usingMovingTargets={props.macroData.movingTargets}
        modifiedSlider={props.macroData.part4Invoked}
        macroData={props.macroData}
        getMacroData={props.getMacroData}
      />
    </>
  );
};

export default UpdateRecentCheckin;